/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getCreditNotesReceipt, getUserDetails } from '../../../api/profileApi';
import {
  getValueFromAppConfig,
  getUserAgentId,
} from '../../../shared/helper-utils/localStorage';
import { useAppContext } from '../../../saas/AppConfigWrapper';

function CreditDebitNoteReceipt() {
  const { appConfig } = useAppContext();
  const { transactionId } = useParams();
  const [agent, setAgent] = useState(undefined);
  const [receipt, setReceipt] = useState(undefined);
  const [hasDetails, setHasDetails] = useState(undefined);

  useEffect(() => {
    document.getElementsByClassName('app-header')[0].style.display = 'none';
    document.getElementsByClassName('app-footer')[0].style.display = 'none';
  }, []);

  const getUserData = async () => {
    const response = await getUserDetails(getUserAgentId());
    if (response.ApiStatus.Status === 'OK') {
      const user = response.ApiStatus.Result.User;
      setAgent(user);
    }
  };

  const getData = async (txid) => {
    const response = await getCreditNotesReceipt(txid);
    if (response?.Root.Status === 'OK') {
      const { CreditDebitNote } = response.Root.Result;
      setReceipt(CreditDebitNote);
      setHasDetails(true);
    }
  };

  useEffect(() => {
    getData(transactionId);
    getUserData();
  }, [transactionId]);
  return (
    <section className="credit-debit-note">
      {hasDetails ? (
        <section className="credit-debit-note_container">
          <h2>{receipt.TxType}</h2>
          <div className="d-flex flex-column mb-1">
            <span>{getValueFromAppConfig('COMPANYNAME')}</span>
            <span>{getValueFromAppConfig('COMPANYADD')}</span>
          </div>
          <div>
            <h5>To</h5>
            {agent && (
              <table className="w-100 agency-details mb-1">
                <tbody>
                  <tr>
                    <td>Agency Name:</td>
                    <td>{agent.Company}</td>
                  </tr>
                  <tr>
                    <td>Address:</td>
                    <td className="d-flex flex-column">
                      <span>{agent.Address1}</span>
                      <span>
                        {agent.City},{agent.PinCode},{agent.Country}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>Email:</td>
                    <td>{agent.ContactEmail}</td>
                  </tr>
                  <tr>
                    <td>Contact:</td>
                    <td>{agent.ContactNumber}</td>
                  </tr>
                </tbody>
              </table>
            )}
          </div>
          <div>
            <h5>Details</h5>
            <table className="transaction-details mb-2">
              <thead>
                <tr>
                  <th>Item</th>
                  <th>Particulars</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Issual Date</td>
                  <td>{receipt.TxDate}</td>
                </tr>
                <tr>
                  <td>TransactionID</td>
                  <td>{receipt.Txid}</td>
                </tr>
                <tr>
                  <td>Issued Towards</td>
                  <td>{receipt.Towards}</td>
                </tr>
                <tr>
                  <td>Reference ID</td>
                  <td>{receipt.ReferenceId}</td>
                </tr>
                <tr>
                  <td>Amount({appConfig?.appCurrency})</td>
                  <td>{receipt.Amount}</td>
                </tr>
                <tr>
                  <td>Admin Remarks</td>
                  <td>{receipt.Remarks}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="fw-bold">
            ps: Being a computer generated statement, signature not required
          </div>
        </section>
      ) : (
        <div className="d-flex justify-content-center p-5">
          <p> No Receipt Found</p>
        </div>
      )}
    </section>
  );
}

export default CreditDebitNoteReceipt;
